import moment from 'moment';

export const fromTime = (timestamp) => { 
    let date = moment.unix(timestamp); 
    return date.format("DD MMMM YYYY");
}

export const fromFormatDate = (date) => { 
    let pieces = date.split("/");
    date = pieces[2] + "-" + pieces[1] + "-" + pieces[0];
    return moment(date).format('DD MMMM YYYY');
}
